module.exports = __webpack_public_path__ + "img/grad-4.7b952719.svg";